/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../../Labels.js';

export class MammalsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'mammals',
            'Mammals',
            allLabels.mammals,
            { numPairs: 6, ...options }
        );
    }
}
